/** Veldschema per bloktype voor de CMS-editor. t = meertalige tekst. */
const t = (key, label, rows) => ({ key, label, type: "t", rows });
const text = (key, label, placeholder) => ({ key, label, type: "text", placeholder });
const num = (key, label, step = 1) => ({ key, label, type: "number", step });
const img = (key, label) => ({ key, label, type: "image" });
const video = (key, label) => ({ key, label, type: "video" });
const sel = (key, label, options) => ({ key, label, type: "select", options });
const items = (key, label, fields, itemLabel) => ({ key, label, type: "items", fields, itemLabel });

const CTA = [t("cta_label", "Knop 1 tekst"), text("cta_link", "Knop 1 link", "/registreren"), t("cta2_label", "Knop 2 tekst"), text("cta2_link", "Knop 2 link", "/login")];
const KOP = [t("eyebrow", "Bovenregel (klein)"), t("titel", "Titel"), t("subtitel", "Subtitel", 2)];

export const BLOCK_SCHEMAS = {
  schap: {
    label: "Winkelschap (hero)",
    uitleg: "Virtueel schap met echte CRM-productfoto's. Merk-toggle schakelt tussen Frankly en NextBrush.",
    fields: [
      ...KOP,
      t("hint", "Kleine toelichting onder de knoppen"),
      ...CTA,
      sel("standaard_merk", "Merk dat eerst getoond wordt", [["frankly", "Frankly"], ["nextbrush", "NextBrush"]]),
      num("max_per_merk", "Maximaal aantal producten per merk (max. 8)"),
      text("skus", "Artikelnummers op het schap (komma-gescheiden, in volgorde; leeg = automatisch)", "FR1001, FR1003, NB1006"),
      sel("hangende_stijl", "NextBrush-producten", [["hangend", "Hangend aan haakjes (door het eurogat in de foto)"], ["staand", "Staand op de plank"]]),
      num("haak_positie", "Hoogte van het eurogat/lusje vanaf de bovenkant van de foto (px, standaard 12)"),
      num("hoogte_frankly_cm", "Standaardhoogte Frankly-product in cm (standaard 17,5)", 0.5),
      num("hoogte_nextbrush_cm", "Standaardhoogte NextBrush-product in cm (standaard 22)", 0.5),
      items("usps", "Per product (op artikelnummer)", [text("sku", "Artikelnummer", "FR1001"), num("hoogte_cm", "Hoogte in cm (leeg = merkstandaard)", 0.5), t("tekst", "USP-tekst", 2)], "Product"),
    ],
  },
  hero: { label: "Hero (tekst + beeld)", fields: [t("titel", "Titel"), t("subtitel", "Subtitel", 3), img("afbeelding", "Afbeelding"), ...CTA] },
  richtext: { label: "Tekst", fields: [t("eyebrow", "Bovenregel (klein)"), t("titel", "Titel"), t("tekst", "Tekst", 6)] },
  "afbeelding-tekst": {
    label: "Afbeelding + tekst",
    fields: [t("eyebrow", "Bovenregel (klein)"), t("titel", "Titel"), t("tekst", "Tekst", 5), img("afbeelding", "Afbeelding"), sel("positie", "Positie afbeelding", [["rechts", "Rechts"], ["links", "Links"]]), t("cta_label", "Knop tekst"), text("cta_link", "Knop link")],
  },
  "afbeeldingen-grid": {
    label: "Grid met kaarten",
    uitleg: "De eerste kaart wordt groot getoond.",
    fields: [...KOP, t("item_cta_label", "Standaard linktekst op kaarten"), items("items", "Kaarten", [t("titel", "Titel"), t("tekst", "Tekst", 2), img("afbeelding", "Afbeelding"), text("link", "Link (optioneel)", "/assortiment")], "Kaart")],
  },
  "cta-banner": { label: "Call-to-action band (donker)", fields: [t("titel", "Titel"), t("tekst", "Tekst", 2), ...CTA] },
  stappen: { label: "Stappenplan", fields: [...KOP, items("items", "Stappen", [t("titel", "Titel"), t("tekst", "Tekst", 2)], "Stap")] },
  "merk-toggle": {
    label: "Merkverhaal met toggle",
    fields: [
      ...KOP,
      t("merk_label", "Labeltekst boven merknaam (bijv. 'Merk')"),
      items("merken", "Merken", [
        text("naam", "Merknaam", "Frankly"),
        t("tagline", "Tagline (cursief)"),
        t("tekst", "Verhaal", 4),
        img("afbeelding", "Beeld"),
        items("usps", "USP's", [t("tekst", "USP")], "USP"),
        t("cta_label", "Knop tekst"),
        text("cta_link", "Knop link"),
      ], "Merk"),
    ],
  },
  voordelen: {
    label: "Voordelen (donker)",
    uitleg: "Merk- en accountneutrale redenen om bij NextProduct in te kopen.",
    fields: [...KOP, items("items", "Voordelen", [sel("icoon", "Icoon", [["package", "Doos / voorraad"], ["tag", "Prijskaartje"], ["store", "Winkel"], ["truck", "Bezorging"], ["shield", "Zekerheid"], ["leaf", "Duurzaam"], ["receipt", "Factuur"], ["clock", "Snel"]]), t("titel", "Titel"), t("tekst", "Tekst", 2)], "Voordeel"), t("cta_label", "Knop tekst"), text("cta_link", "Knop link")],
  },
  faq: { label: "Veelgestelde vragen", fields: [...KOP, items("items", "Vragen", [t("vraag", "Vraag"), t("antwoord", "Antwoord", 3), video("video", "Video (optioneel)"), img("poster", "Video-poster (optioneel)")], "Vraag")] },
  video: {
    label: "Uitlegvideo",
    uitleg: "HTML5-video met poster, titel, knoppen en accent-pill. Upload een MP4 of plak een video-URL.",
    fields: [
      t("eyebrow", "Bovenregel (klein)"),
      t("titel", "Titel"),
      t("subtitel", "Subtitel", 2),
      video("video", "Video (MP4)"),
      img("poster", "Poster / thumbnail"),
      t("pill", "Accent-pill (bijv. 'Bekijk in 50 seconden')"),
      ...CTA,
    ],
  },
  cijfers: {
    label: "Cijfers",
    fields: [sel("stijl", "Stijl", [["donker", "Donker"], ["licht", "Licht"]]), items("items", "Cijfers", [text("prefix", "Voor het getal", "<"), text("waarde", "Getal", "450"), text("suffix", "Achter het getal", "+"), t("label", "Omschrijving")], "Cijfer")],
  },
  testimonials: {
    label: "Retailer-quotes",
    uitleg: "Upload per quote het logo van de winkel; zonder logo tonen we de winkelnaam als woordmerk.",
    fields: [...KOP, items("items", "Quotes", [t("quote", "Quote", 3), img("logo", "Bedrijfslogo"), text("winkel", "Winkel / bedrijf"), text("naam", "Naam"), text("functie", "Functie (bijv. eigenaar)"), text("plaats", "Plaats"), text("link", "Website (optioneel)")], "Quote")],
  },
};

const leegVoor = (field) => {
  if (field.type === "t") return { nl: "", en: "", de: "", fr: "" };
  if (field.type === "items") return [];
  if (field.type === "number") return 0;
  if (field.type === "select") return field.options[0][0];
  return "";
};

export const leegItem = (fields) => Object.fromEntries(fields.map((f) => [f.key, leegVoor(f)]));

export const emptyBlock = (type) => ({
  id: `b${Date.now()}`,
  type,
  ...leegItem(BLOCK_SCHEMAS[type]?.fields || []),
});
